import { jsx } from "react/jsx-runtime";
import { getComponentCssVariables } from "@wix/tpa-style-webpack-plugin/standalone";
import { useMemo } from "react";
import { InputBorderStyle } from "../constants/style-params.js";
const getInputBorderWidths = ({
  styleParams
}) => {
  const borderWidth = styleParams?.numbers?.inputBorderWidth || 1;
  const borderStyle = styleParams?.numbers?.inputBorderStyle ?? 1;
  const defaultBorders = {
    "--inputBorderLeftWidth": borderWidth,
    "--inputBorderRightWidth": borderWidth,
    "--inputBorderTopWidth": borderWidth,
    "--inputBorderBottomWidth": borderWidth
  };
  const borders = {
    [InputBorderStyle.None]: {
      "--inputBorderLeftWidth": 0,
      "--inputBorderRightWidth": 0,
      "--inputBorderTopWidth": 0,
      "--inputBorderBottomWidth": 0
    },
    [InputBorderStyle.Bottom]: {
      "--inputBorderLeftWidth": 0,
      "--inputBorderRightWidth": 0,
      "--inputBorderTopWidth": 0,
      "--inputBorderBottomWidth": borderWidth
    },
    [InputBorderStyle.AllSides]: defaultBorders
  }[borderStyle];
  return borders;
};
const FormTheme = ({ style, children, isMobile }) => {
  const validStylesheet = style && style.styleParams && style.siteTextPresets && style.siteColors;
  const cssVars = useMemo(
    () => validStylesheet && getComponentCssVariables(style, {}, {}, { isMobile }, {}),
    [validStylesheet, style, isMobile]
  );
  const inputBorderWidths = getInputBorderWidths({
    styleParams: style?.styleParams
  });
  if (!validStylesheet || !cssVars) {
    return /* @__PURE__ */ jsx("div", { children });
  }
  return /* @__PURE__ */ jsx("div", { style: { ...cssVars.variables, ...inputBorderWidths }, children });
};
export {
  FormTheme
};
//# sourceMappingURL=form-theme.js.map
